module.exports = __webpack_public_path__ + "static/media/ic-local-pin.2e24afb8.svg";